/* 转换为日期对象, 非法日期直接抛错
@value Date | String | Number: 原生日期对象, 日期值或毫秒时间戳
*/
const INVALID_DATE = 'Invalid Date'

export default function (value) {
  if (value === null || value === void 0) {
    throw new Error(INVALID_DATE)
  }
  // 时间戳有可能存成字符串
  if (typeof value === 'string') {
    // 没有:号(时分秒)时2018-08-08替换为2018/08/08, 以保证两者的值一致
    // new Date('2018/08/08').getHours() === 0  new Date('2018-08-08').getHours() === 8
    if (value.indexOf(':') === -1) {
      value = value.replace(/-/g, '/')
    } else {
      const idx = value.lastIndexOf(' ')

      if (idx > -1) {
        let ymd = value.substring(0, idx)
        let hms = value.substring(idx + 1, value.length)

        ymd = ymd.replace(/\//g, '-')
        // '2018 11 09 10:00:00'
        ymd = ymd.replace(/\s+/g, '/')

        value = ymd + ' ' + hms
      }
    }

    const timestamp = Number(value)

    if (!Number.isNaN(timestamp)) {
      value = timestamp
    }
  }

  let date = new Date(value)

  if (date.toString() === INVALID_DATE) {
    // IOS new Date('2018-11-09 10:00:00').getFullYear() === null
    if (typeof value === 'string' && value.lastIndexOf(':') > -1) {
      const index = value.lastIndexOf(' ')

      if (index > -1) {
        value = value.substring(0, index) + 'T' + value.substring(index + 1, value.length)
      }
    }

    date = new Date(value)

    if (date.toString() === INVALID_DATE) {
      throw new Error(INVALID_DATE)
    }
  }
  // 2018-11-09T10:00:00这种格式, ios直接new Date('2018-11-09T10:00:00')出来的是不准确的, 需要再处理下
  if (typeof value === 'string' && value.indexOf('T') > -1) {
    const local = value.split('T')
    const ymd = local[0].split('-')
    const hms = local[1].split(':')

    date = new Date(ymd[0], ymd[1] - 1, ymd[2], hms[0] || 0, hms[1] || 0, hms[2] || 0)
  }

  return date
}